import React from "react";

import { Badge } from "@/components/ui/Badge";

/**
 * Per-database outcome of a fleet action. One row per database, because a fleet
 * action succeeds and fails per database and a single verdict would hide that.
 *
 * @param {Array} results  rows of { key, success, error, ... }
 * @param {Function} renderDetail  (row) => the middle line, e.g. "abc123 → def456"
 */
const ResultList = ({ results, renderDetail }) => (
  <div className="rounded-md border border-border-primary divide-y divide-border-primary text-xs">
    {results.map((r) => (
      <div key={r.key} className="px-3 py-2 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="font-mono text-text-primary truncate" title={r.key}>
            {r.key}
          </div>
          <div className="text-text-secondary mt-0.5">{renderDetail(r)}</div>
          {r.error && <div className="text-tone-rose mt-1 whitespace-pre-wrap break-words">{r.error}</div>}
        </div>
        <Badge
          variant="solid"
          colorIndex={r.success ? 3 : 1}
          label={r.success ? "applied" : "failed"}
          className="rounded-full shrink-0"
          badgeStyle="px-2 py-0.5 text-[11px] font-medium"
        />
      </div>
    ))}
  </div>
);

export default ResultList;
